module.exports = __webpack_public_path__ + "static/media/aoi.c13fa089.zip";